import { render, staticRenderFns } from "./ApproveALF.vue?vue&type=template&id=3181134e"
import script from "./ApproveALF.vue?vue&type=script&lang=js"
export * from "./ApproveALF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports